import { Button, DropdownMenu, HStack, Icon } from '@betterment/samba-react';

import { SecurityPositionDetailsMode, useSecurityPositionDetailsMode } from './security-position-details-mode';

export const SecurityPositionDetailsModeDropdown: React.FC = () => {
  const [detailsMode, setDetailsMode] = useSecurityPositionDetailsMode();
  const modeNames: Record<SecurityPositionDetailsMode, string> = {
    [SecurityPositionDetailsMode.Total]: 'Total gain/loss',
    [SecurityPositionDetailsMode.Today]: "Today's gain/loss",
  };

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild={true}>
        <Button variant="textPrimary" color="text">
          <HStack css={{ gap: 'space.50', alignItems: 'center', color: 'text' }}>
            {modeNames[detailsMode]}
            <Icon name="CaretDown" size="small" />
          </HStack>
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" side="bottom">
        {[SecurityPositionDetailsMode.Today, SecurityPositionDetailsMode.Total].map(mode => (
          <DropdownMenu.Item key={mode} onSelect={() => setDetailsMode(mode)}>
            {modeNames[mode]}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
